import { Navigate, useLocation } from "react-router-dom";
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from "../hooks/useLocalePath";

const LOCALE_STORAGE_KEY = "asm-locale";

function getStoredLocale() {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch {
    // localStorage unavailable
  }
  return DEFAULT_LOCALE;
}

const LOCALE_PREFIX_REGEX = new RegExp(`^/(${SUPPORTED_LOCALES.join("|")})`);

export default function LocaleRedirect() {
  const location = useLocation();
  const locale = getStoredLocale();

  // Strip any existing locale prefixes to prevent /sv/sv/sv loops
  let cleanPath = location.pathname;
  while (LOCALE_PREFIX_REGEX.test(cleanPath)) {
    cleanPath = cleanPath.replace(LOCALE_PREFIX_REGEX, "");
  }
  if (!cleanPath.startsWith("/")) cleanPath = `/${cleanPath}`;

  const target = `/${locale}${cleanPath}${location.search}${location.hash}`;
  return <Navigate to={target} replace />;
}
